import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const MuteIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M4.87333 15.2244H3.11111C2.81643 15.2244 2.53381 15.1073 2.32544 14.899C2.11706 14.6906 2 14.408 2 14.1133V9.66884C2 9.37416 2.11706 9.09154 2.32544 8.88317C2.53381 8.6748 2.81643 8.55773 3.11111 8.55773H4.87333L10.1033 3.32773C10.8033 2.62773 12 3.12329 12 4.11329V19.6688C12 20.6588 10.8033 21.1544 10.1033 20.4544L4.87333 15.2244Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5555 14.1133L19.7778 11.891M19.7778 11.891L22 9.66882M19.7778 11.891L17.5555 9.66882M19.7778 11.891L22 14.1133"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

MuteIcon.displayName = 'MuteIcon';
